module.exports = __webpack_public_path__ + "img/45.f54e172a.png";